/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order
import { splitTestEnabled } from 'lib/helpers';

import 'components/search/search-results/search-results';
import 'components/search/search-infinite/search-infinite';
import 'components/util/tags-carousel/tags-carousel';

import(
  /* webpackChunkName: "ez-carousel-controller" */
  /* webpackPreload: true */
  'components/util/ez-carousel/ez-carousel-controller'
).then((controller) => {
  EezyStimulusApplication.register('ez-carousel', controller.default);
});

import(
  /* webpackChunkName: "num-pager-controller" */
  /* webpackPreload: true */
  'components/util/num-pager/num-pager-controller'
).then((controller) => {
  EezyStimulusApplication.register('ez-num-pager', controller.default);
});

import(
  /* webpackChunkName: "search-tag-controller" */
  /* webpackPreload: true */
  'components/search/search-tags/search-tag-controller'
).then((controller) => {
  EezyStimulusApplication.register('search-tag', controller.default);
});

/* start: split-test iscroll_modal */
import SearchInfiniteController from 'components/search/search-infinite/search-infinite-controller';
if (splitTestEnabled('iscroll-modal')) {
  EezyStimulusApplication.register('search-infinite', SearchInfiniteController);
}
/* end: split-test iscroll_modal */
